require('core-js/es');
require('regenerator-runtime/runtime');

const {
  loadCanvasToBlobPolyfill,
  loadFetchPolyfill,
  loadGlobalThisPolyfill,
  loadImmerPolyfill,
  loadInertPolyfill,
  loadISOPolyfill,
  loadRafPolyfill,
  loadUrlPolyfill,
  loadArrayAtPolyfill,
  loadStringAtPolyfill,
} = require('./app/polyfills');

Promise.all([
  // web standard
  loadCanvasToBlobPolyfill(),
  loadFetchPolyfill(),
  loadGlobalThisPolyfill(),
  loadInertPolyfill(),
  loadISOPolyfill(),
  loadRafPolyfill(),
  loadUrlPolyfill(),
  loadArrayAtPolyfill(),
  loadStringAtPolyfill(),
  // library
  loadImmerPolyfill(),
]).then(() => {
  require('./app');
});

export {};
